// extracted by mini-css-extract-plugin
export var header = "_ue-1";
export var maskBottom = "_ue-6";
export var maskMiddle = "_ue-7";
export var maskTop = "_ue-5";
export var root = "_ue-0";
export var scrollDownButton = "_ue-3";
export var scrollDownButtonHidden = "_ue-4";
export var viewport = "_ue-2";